import { useEffect, useRef } from "react";
import { getLastActivity } from "./useActivityTracker";

const INACTIVITY_TIMEOUT_MS = 20 * 60 * 1000; // 20 minutes
const CHECK_INTERVAL_MS = 30 * 1000; // check every 30 seconds

/**
 * Hook that checks every 30 seconds if the user has been inactive
 * for more than 10 minutes and logs them out if so.
 * Only active when a token exists.
 */
export function useAutoLogout() {
  const intervalRef = useRef(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      const token = localStorage.getItem("token");
      if (!token) return;

      const lastActivity = getLastActivity();
      if (lastActivity && Date.now() - lastActivity > INACTIVITY_TIMEOUT_MS) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/login";
      }
    }, CHECK_INTERVAL_MS);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);
}
